<div #root class="workspace">
  <!-- Left: the map's tools, or (in List view) just the view switch. -->
  <aside app-suburb-tools class="tools"></aside>

  <!-- Centre: the map (kept alive in List view, so switching back is instant) or the list. -->
  <main class="stage">
    <div class="map-view" [hidden]="state.view !== 'map'">
      <div #mapEl class="map"></div>
      <canvas #lassoEl class="lasso"></canvas>
      <div *ngIf="state.loading" class="overlay-msg">Loading the suburb map…</div>
      <div *ngIf="state.loadError" class="overlay-msg err">The suburb map couldn't load: {{ state.loadError }}</div>
      <div *ngIf="state.hover as hover" class="hover" [style.left.px]="hover.x + 14" [style.top.px]="hover.y + 14">
        <div class="h-name">{{ hover.name }}</div>
        <div *ngIf="hover.regionId; else unassigned" class="h-region">{{ catalogue.regionName(hover.regionId) }}{{ hover.covered ? ' · has a page' : '' }}</div>
        <ng-template #unassigned><div class="h-none">unassigned</div></ng-template>
        <div *ngIf="hover.subRegions.length" class="h-sub">part of {{ hover.subRegions.join(', ') }}</div>
        <div *ngIf="hover.page" class="h-page">page: {{ hover.page }}</div>
      </div>
      <!-- A place's popup, above its marker (#253 step 3). -->
      <app-suburb-place-popup *ngIf="places.popupPlace && places.popupPos as pos" class="place-popup" [class.below]="pos.below" [style.left.px]="pos.x" [style.top.px]="pos.y"
                              [below]="pos.below" [arrowShift]="pos.shift"
                              [place]="places.popupPlace" [readOnly]="state.readOnly" [autoAdd]="places.popupAutoAdd"
                              (changed)="onPlaceChanged($event)" (details)="popupDetails($event)" (closed)="places.closePopup()"></app-suburb-place-popup>
    </div>
    <div class="list-view" *ngIf="state.view === 'list'">
      <app-suburb-data-list [regionNames]="catalogue.regionNames" [regionOptions]="catalogue.regionOptions" [subRegionNames]="catalogue.subRegionNames"
                            [subRegionGroups]="catalogue.subRegionGroups" [otherPages]="records.otherPages().length"
                            (open)="nav.openSuburb($event)" (openOtherPages)="nav.openOtherPages()"></app-suburb-data-list>
    </div>
    <!-- Readiness (#262): every suburb page, what it has and what's missing. -->
    <div class="list-view" *ngIf="state.view === 'readiness'">
      <app-suburb-readiness></app-suburb-readiness>
    </div>
    <!-- The block preview (#263): what the editor in the side panel holds, drawn by the website, beside the panel. -->
    <div class="preview-view" *ngIf="state.view === 'preview'" [class.beside-panel]="!!state.panel">
      <app-block-preview layout="stage" [source]="stagePreview.source" (closed)="stagePreview.close()"></app-block-preview>
    </div>

    <!-- The side panel: slides in over the right of the stage. -->
    <section app-suburb-side-panel class="side-panel" [class.open]="!!state.panel" aria-label="Suburb panel"></section>
  </main>
</div>

<p-dialog header="Confirm" [visible]="!!state.confirm" [modal]="true" [closable]="false" [style]="{ width: '32rem' }" [baseZIndex]="12000" appendTo="body">
  <p class="m-0">{{ state.confirm?.message }}</p>
  <ng-template pTemplate="footer">
    <button pButton type="button" class="p-button-text" label="Cancel" (click)="state.answer(false)"></button>
    <button pButton type="button" label="Go ahead" (click)="state.answer(true)"></button>
  </ng-template>
</p-dialog>
